export const blocFConstants = {
  GET_BLOCF_REQUEST: 'GET_BLOCF_REQUEST',
  GET_BLOCF_SUCCESS: 'GET_BLOCF_SUCCESS',
  GET_BLOCF_FAILURE: 'GET_BLOCF_FAILURE',

  UPDATE_BLOCF_REQUEST: 'UPDATE_BLOCF_REQUEST',
  UPDATE_BLOCF_SUCCESS: 'UPDATE_BLOCF_SUCCESS',
  UPDATE_BLOCF_FAILURE: 'UPDATE_BLOCF_FAILURE',
};
